import angular from 'angular'

import template from '../../../templates/register-closure/wr-register-closure-form.html'
import { STATES } from '../../../../lib/routes'
import { $state } from '../../ng-compat/imports'
import { SaleManager } from '../../managers/sale-manager'

/**
 * The form where a user can summarise and submit a register closure.
 *
 * @module webregister.directives.wrRegisterClosureForm
 */
angular
  .module('webregister.directives')
  .directive('wrRegisterClosureForm', function () {
    return {
      scope: {
        registerClosure: '=',
      },
      restrict: 'E',
      template,
      controllerAs: 'registerClosureFormCtrl',
      bindToController: true,

      /**
       * =======================================
       * REGISTER CLOSURE FORM CONTROLLER
       * =======================================
       */
      controller(
        this: $TSFixMe,
        $scope,
        registerClosureManager,
        vdToastNotificationService,
        saleManager: SaleManager,
        saleModals
      ) {
        registerClosureManager.setTimeInitialized(new Date())

        /**
         * Close the register, posting the register closure data to the server.
         *
         * @private
         * @method _doCloseRegister
         *
         * @return {Promise} A promise resolved once the register has been closed
         */
        this._doCloseRegister = function () {
          this.closingRegister = true
          registerClosureManager.setTimeClosed(new Date())

          return registerClosureManager
            .closeRegister(this.registerClosure)
            .catch(() => {
              this.closingRegister = false
            })
            .then(() => $state.go(STATES.RESOLVE_REGISTER_CLOSURE_STATE))
        }

        /**
         * Close the register, submitting the filled out summary to the server. A toast notification will be displayed
         * if the form is invalid. Once valid it will first confirm that the user is sure they wish to close the register.
         *
         * @method closeRegister
         *
         * @return {Promise} A promise resolved once the register has been closed
         */
        this.closeRegister = function (closureSummaryForm: $TSFixMe) {
          if (saleManager.hasActiveSale()) {
            return saleManager.actionExistingSaleIfRequired({
              context: saleModals.CONTEXTS.CLOSE_REGISTER,
            })
          }

          // Display toast notification if form is invalid
          if (!closureSummaryForm.$valid) {
            return vdToastNotificationService.negative({
              message: 'Please enter the amount for the highlighted fields.',
            })
          } else {
            return this._doCloseRegister()
          }
        }

        /**
         * Update the register sale note.
         *
         * @method updateNote
         */
        this.updateNote = (newNote: string): void => {
          $scope.$applyAsync(() => {
            this.registerClosure = {
              ...this.registerClosure,
              note: newNote,
            }
          })
        }

        $scope.$watch(
          'registerClosureFormCtrl.registerClosure',
          function (registerClosure: $TSFixMe) {
            registerClosureManager.saveRegisterClosure(registerClosure)
          },
          true
        )
      },
    }
  })
